(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kpAJq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $edc2a29cd8af8d61$export$7c398597f8905a1; });
function $edc2a29cd8af8d61$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $edc2a29cd8af8d61$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $edc2a29cd8af8d61$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $edc2a29cd8af8d61$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("emxKn", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $a74d4c3a6d8fc754$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $cZhbL = parcelRequire("cZhbL");
var $a74d4c3a6d8fc754$var$extendStatics = function extendStatics1(d, b) {
    $a74d4c3a6d8fc754$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a74d4c3a6d8fc754$var$extendStatics(d, b);
};
function $a74d4c3a6d8fc754$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a74d4c3a6d8fc754$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a74d4c3a6d8fc754$export$18ce0697a983be9b = function __assign1() {
    $a74d4c3a6d8fc754$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a74d4c3a6d8fc754$export$18ce0697a983be9b.apply(this, arguments);
};
function $a74d4c3a6d8fc754$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a74d4c3a6d8fc754$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a74d4c3a6d8fc754$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a74d4c3a6d8fc754$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a74d4c3a6d8fc754$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a74d4c3a6d8fc754$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $cZhbL._)(x)) === "symbol" ? x : "".concat(x);
}
function $a74d4c3a6d8fc754$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $cZhbL._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a74d4c3a6d8fc754$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a74d4c3a6d8fc754$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a74d4c3a6d8fc754$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a74d4c3a6d8fc754$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a74d4c3a6d8fc754$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a74d4c3a6d8fc754$export$45d3717a4c69092e(o, m, p);
}
function $a74d4c3a6d8fc754$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a74d4c3a6d8fc754$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a74d4c3a6d8fc754$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a74d4c3a6d8fc754$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a74d4c3a6d8fc754$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a74d4c3a6d8fc754$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a74d4c3a6d8fc754$export$10c90e4f7922046c(v) {
    return this instanceof $a74d4c3a6d8fc754$export$10c90e4f7922046c ? (this.v = v, this) : new $a74d4c3a6d8fc754$export$10c90e4f7922046c(v);
}
function $a74d4c3a6d8fc754$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a74d4c3a6d8fc754$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a74d4c3a6d8fc754$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a74d4c3a6d8fc754$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a74d4c3a6d8fc754$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a74d4c3a6d8fc754$export$19a8beecd37a4c45 === "function" ? $a74d4c3a6d8fc754$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a74d4c3a6d8fc754$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a74d4c3a6d8fc754$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a74d4c3a6d8fc754$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a74d4c3a6d8fc754$export$45d3717a4c69092e(result, mod, k);
    }
    $a74d4c3a6d8fc754$var$__setModuleDefault(result, mod);
    return result;
}
function $a74d4c3a6d8fc754$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a74d4c3a6d8fc754$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a74d4c3a6d8fc754$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a74d4c3a6d8fc754$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a74d4c3a6d8fc754$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a74d4c3a6d8fc754$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a74d4c3a6d8fc754$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a74d4c3a6d8fc754$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a74d4c3a6d8fc754$export$2e2bcd8739ae039 = {
    __extends: $a74d4c3a6d8fc754$export$a8ba968b8961cb8a,
    __assign: $a74d4c3a6d8fc754$export$18ce0697a983be9b,
    __rest: $a74d4c3a6d8fc754$export$3c9a16f847548506,
    __decorate: $a74d4c3a6d8fc754$export$29e00dfd3077644b,
    __param: $a74d4c3a6d8fc754$export$d5ad3fd78186038f,
    __metadata: $a74d4c3a6d8fc754$export$f1db080c865becb9,
    __awaiter: $a74d4c3a6d8fc754$export$1050f835b63b671e,
    __generator: $a74d4c3a6d8fc754$export$67ebef60e6f28a6,
    __createBinding: $a74d4c3a6d8fc754$export$45d3717a4c69092e,
    __exportStar: $a74d4c3a6d8fc754$export$f33643c0debef087,
    __values: $a74d4c3a6d8fc754$export$19a8beecd37a4c45,
    __read: $a74d4c3a6d8fc754$export$8d051b38c9118094,
    __spread: $a74d4c3a6d8fc754$export$afc72e2116322959,
    __spreadArrays: $a74d4c3a6d8fc754$export$6388937ca91ccae8,
    __spreadArray: $a74d4c3a6d8fc754$export$1216008129fb82ed,
    __await: $a74d4c3a6d8fc754$export$10c90e4f7922046c,
    __asyncGenerator: $a74d4c3a6d8fc754$export$e427f37a30a4de9b,
    __asyncDelegator: $a74d4c3a6d8fc754$export$bbd80228419bb833,
    __asyncValues: $a74d4c3a6d8fc754$export$e3b29a3d6162315f,
    __makeTemplateObject: $a74d4c3a6d8fc754$export$4fb47efe1390b86f,
    __importStar: $a74d4c3a6d8fc754$export$c21735bcef00d192,
    __importDefault: $a74d4c3a6d8fc754$export$da59b14a69baef04,
    __classPrivateFieldGet: $a74d4c3a6d8fc754$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a74d4c3a6d8fc754$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a74d4c3a6d8fc754$export$81fdc39f203e4e04,
    __addDisposableResource: $a74d4c3a6d8fc754$export$88ac25d8e944e405,
    __disposeResources: $a74d4c3a6d8fc754$export$8f076105dc360e92
};

});
parcelRegister("cZhbL", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $974883d8f59f0dc7$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $974883d8f59f0dc7$export$5f0017c582d45a2d; });
function $974883d8f59f0dc7$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("kD3Id", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $f04a544d25f25bae$export$a4ad2735b021c132; });
$parcel$export(module.exports, "CODENAME", function () { return $f04a544d25f25bae$export$3a069fb8a789ba42; });
$parcel$export(module.exports, "download", function () { return $f04a544d25f25bae$export$24422be91ad4011f; });
$parcel$export(module.exports, "AppleUUID", function () { return $f04a544d25f25bae$export$456c2dc32ad270e7; });
$parcel$export(module.exports, "Profile", function () { return $f04a544d25f25bae$export$5120f2d0b8d4cab8; });
$parcel$export(module.exports, "fetchIcon", function () { return $f04a544d25f25bae$export$afc5f872014f86e1; });
$parcel$export(module.exports, "isurl", function () { return $f04a544d25f25bae$export$ab121bdcf1af9a59; });
$parcel$export(module.exports, "escape", function () { return $f04a544d25f25bae$export$4e7f196112fea3c5; });

var $kpAJq = parcelRequire("kpAJq");

var $kyJin = parcelRequire("kyJin");

var $9Ptd6 = parcelRequire("9Ptd6");

var $k0eEn = parcelRequire("k0eEn");

var $6rjMR = parcelRequire("6rjMR");

var $emxKn = parcelRequire("emxKn");
var $f04a544d25f25bae$export$dec50f0fa4f3786a = new XMLSerializer();
var $f04a544d25f25bae$export$a4ad2735b021c132 = localStorage.getItem("pwastore_experiments") ? "2.1" : "2.0";
var $f04a544d25f25bae$export$3a069fb8a789ba42 = localStorage.getItem("pwastore_experiments") ? "Alpinya" : "Straltea";
if (!("randomUUID" in crypto)) // https://stackoverflow.com/a/2117523/2800218
// LICENSE: https://creativecommons.org/licenses/by-sa/4.0/legalcode
crypto.randomUUID = function randomUUID() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
};
if (!("URLSearchParams" in window)) {
    window.URLSearchParams = function(q) {
        var _this = this;
        this.p = new Map();
        if (q) q.replace(/^\?/, "").split("&").forEach(function(i) {
            var _i_split_map = (0, $k0eEn._)(i.split("=").map(decodeURIComponent), 2), k = _i_split_map[0], v = _i_split_map[1];
            _this.p.set(k, (0, $6rjMR._)(_this.p.get(k) || []).concat([
                v
            ]));
            _this[k] = _this.p.get(k);
        });
    };
    window.URLSearchParams.prototype.get = function(k) {
        return (this.p.get(k) || [])[0] || null;
    };
    window.URLSearchParams.prototype.has = function(k) {
        return this.p.has(k);
    };
    window.URLSearchParams.prototype.toString = function() {
        return (0, $6rjMR._)(this.p.entries()).map(function(param) {
            var _param = (0, $k0eEn._)(param, 2), k = _param[0], v = _param[1];
            return v.map(function(v) {
                return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v));
            }).join("&");
        }).join("&");
    };
}
function $f04a544d25f25bae$export$24422be91ad4011f(name, url) {
    var revoke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var a = document.createElement("a");
    a.download = name;
    a.href = url;
    document.body.append(a);
    a.click();
    document.body.removeChild(a);
    a.remove();
    if (revoke) setTimeout(function() {
        return URL.revokeObjectURL(url);
    }, 1000);
}
function $f04a544d25f25bae$export$456c2dc32ad270e7() {
    return crypto.randomUUID().toUpperCase();
}
function $f04a544d25f25bae$export$35059013cd4a06db(doc, tag, content) {
    var n = doc.createElement(tag);
    if (content) n.appendChild(doc.createTextNode(content));
    return n;
}
// https://stackoverflow.com/a/47317538
var $f04a544d25f25bae$var$prettifyXml = function prettifyXml(xmlDoc) {
    var xsltDoc = new DOMParser().parseFromString([
        // describes how we want to modify the XML - indent everything
        '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
        '  <xsl:strip-space elements="*"/>',
        '  <xsl:template match="para[content-style][not(text())]">',
        '    <xsl:value-of select="normalize-space(.)"/>',
        "  </xsl:template>",
        '  <xsl:template match="node()|@*">',
        '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
        "  </xsl:template>",
        '  <xsl:output indent="yes"/>',
        "</xsl:stylesheet>"
    ].join("\n"), "application/xml");
    var xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    var resultXml = new XMLSerializer().serializeToString(resultDoc);
    return resultXml;
};
var $f04a544d25f25bae$export$5120f2d0b8d4cab8 = /*#__PURE__*/ function() {
    "use strict";
    function Profile(id, name, desc, ver) {
        var org = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "PWA Store", uuid = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : $f04a544d25f25bae$export$456c2dc32ad270e7();
        (0, $kyJin._)(this, Profile);
        this.id = id;
        this.ver = ver;
        this.doc = document.implementation.createDocument("", "", null);
        this.plist = $f04a544d25f25bae$export$35059013cd4a06db(this.doc, "plist");
        this.plist.setAttribute("version", "1.0");
        this.dict = $f04a544d25f25bae$export$35059013cd4a06db(this.doc, "dict");
        this.plist.append(this.dict);
        this.doc.append(this.plist);
        this.array = $f04a544d25f25bae$export$35059013cd4a06db(this.doc, "array");
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadContent"));
        this.dict.append(this.array);
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadDescription"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", desc));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadDisplayName"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", name));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadIdentifier"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", id));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadOrganization"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", org));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadRemovalDisallowed"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "false"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadType"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "Configuration"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadUUID"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", uuid));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadVersion"));
        this.dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "integer", ver));
    }
    (0, $9Ptd6._)(Profile, [
        {
            key: "certificatePEM",
            value: function certificatePEM(name, data, ver) {
                var uuid = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $f04a544d25f25bae$export$456c2dc32ad270e7();
                var dict = $f04a544d25f25bae$export$35059013cd4a06db(this.doc, "dict");
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadCertificateFileName"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", name));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadContent"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "data", data));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadDescription"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "Configures a Certificate"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadDisplayName"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", name));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadIdentifier"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "app.pwastore.cert." + uuid));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadType"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "com.apple.security.pem"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadUUID"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", uuid));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadVersion"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "integer", ver));
                this.array.append(dict);
                return this;
            }
        },
        {
            key: "certificateRoot",
            value: function certificateRoot(name, der, ver) {
                var uuid = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $f04a544d25f25bae$export$456c2dc32ad270e7();
                var dict = $f04a544d25f25bae$export$35059013cd4a06db(this.doc, "dict");
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadCertificateFileName"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", name));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadContent"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "data", btoa(String.fromCharCode.apply(null, der)).match(/.{1,64}/g).join("\n")));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadDescription"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "Configures a Root Certificate"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadDisplayName"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", name));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadIdentifier"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "app.pwastore.cert." + uuid));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadType"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "com.apple.security.root"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadUUID"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", uuid));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadVersion"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "integer", ver));
                this.array.append(dict);
                return this;
            }
        },
        {
            key: "webClip",
            value: function webClip(name, url, iconb64, ver) {
                var uuid = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $f04a544d25f25bae$export$456c2dc32ad270e7(), scoped = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
                var dict = $f04a544d25f25bae$export$35059013cd4a06db(this.doc, "dict");
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "FullScreen"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "true"));
                if (iconb64) {
                    dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "Icon"));
                    dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "data", iconb64));
                }
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "IgnoreManifestScope"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, scoped ? "true" : "false"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "IsRemovable"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "true"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "Label"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", name));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadDescription"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "Configures a PWA clip"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadDisplayName"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", name));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadIdentifier"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "com.apple.webClip.managed." + uuid));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadType"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", "com.apple.webClip.managed"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadUUID"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", uuid));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "PayloadVersion"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "integer", ver));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "Precomposed"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "false"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "key", "URL"));
                dict.append($f04a544d25f25bae$export$35059013cd4a06db(this.doc, "string", url));
                this.array.append(dict);
                return this;
            }
        },
        {
            key: "string",
            value: function string() {
                return '<?xml version="1.0" encoding="UTF-8"?>\n<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">\n' + $f04a544d25f25bae$var$prettifyXml(this.doc);
            }
        },
        {
            key: "blob",
            value: function blob() {
                return new Blob([
                    this.string()
                ], {
                    type: "application/x-apple-aspen-config"
                });
            }
        },
        {
            key: "url",
            value: function url() {
                return URL.createObjectURL(this.blob());
            }
        }
    ]);
    return Profile;
}();
function $f04a544d25f25bae$export$2a37c56e07d95303(buffer) {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for(var i = 0; i < len; i++)binary += String.fromCharCode(bytes[i]);
    return window.btoa(binary);
}
function $f04a544d25f25bae$export$afc5f872014f86e1(url, opt) {
    return $f04a544d25f25bae$var$_fetchIcon.apply(this, arguments);
}
function $f04a544d25f25bae$var$_fetchIcon() {
    $f04a544d25f25bae$var$_fetchIcon = (0, $kpAJq._)(function(url, opt) {
        var _f_headers_get, f, d, svgurl, svg;
        return (0, $emxKn.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(url, opt)
                    ];
                case 1:
                    f = _state.sent();
                    return [
                        4,
                        f.arrayBuffer()
                    ];
                case 2:
                    d = _state.sent();
                    if (!((_f_headers_get = f.headers.get("Content-Type")) === null || _f_headers_get === void 0 ? void 0 : _f_headers_get.includes("svg"))) return [
                        3,
                        4
                    ];
                    svgurl = URL.createObjectURL(new Blob([
                        d
                    ], {
                        type: "image/svg+xml"
                    }));
                    svg = document.createElement("img");
                    svg.width = svg.height = "64px";
                    svg.src = svgurl;
                    return [
                        4,
                        new Promise(function(res) {
                            svg.onload = function() {
                                var cnv = document.createElement("canvas");
                                cnv.width = cnv.height = 64;
                                var ctx = cnv.getContext("2d");
                                ctx.drawImage(svg, 0, 0);
                                cnv.toBlob(function() {
                                    var _ref = (0, $kpAJq._)(function(blob) {
                                        return (0, $emxKn.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    URL.revokeObjectURL(svgurl);
                                                    return [
                                                        4,
                                                        blob.arrayBuffer()
                                                    ];
                                                case 1:
                                                    res.apply(void 0, [
                                                        $f04a544d25f25bae$export$2a37c56e07d95303.apply(void 0, [
                                                            _state.sent()
                                                        ])
                                                    ]);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(blob) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                            };
                        })
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    return [
                        2,
                        $f04a544d25f25bae$export$2a37c56e07d95303(d)
                    ];
            }
        });
    });
    return $f04a544d25f25bae$var$_fetchIcon.apply(this, arguments);
}
function $f04a544d25f25bae$export$ab121bdcf1af9a59(str) {
    var url;
    try {
        url = new URL(str);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}
function $f04a544d25f25bae$export$4e7f196112fea3c5(text) {
    var _text_replace_replace_replace, _text_replace_replace, _text_replace;
    return text === null || text === void 0 ? void 0 : (_text_replace = text.replace(/&/g, "&amp;")) === null || _text_replace === void 0 ? void 0 : (_text_replace_replace = _text_replace.replace(/</g, "&lt;")) === null || _text_replace_replace === void 0 ? void 0 : (_text_replace_replace_replace = _text_replace_replace.replace(/>/g, "&gt;")) === null || _text_replace_replace_replace === void 0 ? void 0 : _text_replace_replace_replace.replace(/\n/g, "<br>");
}
window.$ = function(s) {
    return document.querySelector(s);
};

});
parcelRegister("kyJin", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ef7a1e596503393d$export$2996f80ef42b8419; });
function $ef7a1e596503393d$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9Ptd6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $727f890b6bcd259f$export$d60067ff2358eee8; });
function $727f890b6bcd259f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $727f890b6bcd259f$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $727f890b6bcd259f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $727f890b6bcd259f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("k0eEn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e8ff2bf5c94eb66e$export$fdf2a89c76341bbf; });

var $qcfWx = parcelRequire("qcfWx");

var $j4K3z = parcelRequire("j4K3z");

var $6N7fG = parcelRequire("6N7fG");

var $j1rRb = parcelRequire("j1rRb");
function $e8ff2bf5c94eb66e$export$fdf2a89c76341bbf(arr, i) {
    return (0, $qcfWx._array_with_holes)(arr) || (0, $j4K3z._iterable_to_array_limit)(arr, i) || (0, $j1rRb._unsupported_iterable_to_array)(arr, i) || (0, $6N7fG._non_iterable_rest)();
}

});
parcelRegister("qcfWx", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $04ebefa37e661845$export$e6256bf45c68d561; });
function $04ebefa37e661845$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("j4K3z", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $de321df0f058a575$export$2fd15edff6687200; });
function $de321df0f058a575$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("6N7fG", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $4f1cf1c360627743$export$60dbc22abd7da546; });
function $4f1cf1c360627743$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("j1rRb", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $dd93b8134ed8e103$export$a5be06335b3a083c; });

var $dgJsl = parcelRequire("dgJsl");
function $dd93b8134ed8e103$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $dgJsl._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $dgJsl._array_like_to_array)(o, minLen);
}

});
parcelRegister("dgJsl", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $9a9007a6b5b503bb$export$79e617b1955a2616; });
function $9a9007a6b5b503bb$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("6rjMR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4b049cfced27bb3d$export$1b5e630bc3aea29f; });

var $5Mvrf = parcelRequire("5Mvrf");

var $gjb7z = parcelRequire("gjb7z");

var $69hPL = parcelRequire("69hPL");

var $j1rRb = parcelRequire("j1rRb");
function $4b049cfced27bb3d$export$1b5e630bc3aea29f(arr) {
    return (0, $5Mvrf._array_without_holes)(arr) || (0, $gjb7z._iterable_to_array)(arr) || (0, $j1rRb._unsupported_iterable_to_array)(arr) || (0, $69hPL._non_iterable_spread)();
}

});
parcelRegister("5Mvrf", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $4359d276ed095f2f$export$7e0947b5ad3404e2; });

var $dgJsl = parcelRequire("dgJsl");
function $4359d276ed095f2f$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $dgJsl._array_like_to_array)(arr);
}

});

parcelRegister("gjb7z", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $bdf70c1fe50ac35a$export$1eb58a6e75231000; });
function $bdf70c1fe50ac35a$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("69hPL", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $47a16ac48a1e7dbd$export$e6f3c4780d19eb2b; });
function $47a16ac48a1e7dbd$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("dliKA", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $9b6bc7f66eba310c$export$c2c98ac76e997b63; });
function $9b6bc7f66eba310c$export$c2c98ac76e997b63(o, p) {
    $9b6bc7f66eba310c$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9b6bc7f66eba310c$export$c2c98ac76e997b63(o, p);
}

});

parcelRegister("62B8c", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $465fbb7cf94d1bdd$export$685354647fba1516; });
function $465fbb7cf94d1bdd$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

})();
//# sourceMappingURL=index.93939d29.js.map
